// extracted by mini-css-extract-plugin
export default {"container":"CategoriesFilter_container__jtTu2","item":"CategoriesFilter_item__oq2Zn","itemActive":"CategoriesFilter_itemActive__jw3SF"};